import { type ReactNode } from 'react'
import { css } from '@emotion/react'
import {
  Alert,
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { type AlertProps } from '@livechat/design-system-react-components/dist/components/Alert/Alert'

const alertCss = css`
  h5,
  p {
    margin: 0;
  }
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
  margin-top: var(${SpacingToken.Spacing5});
  container-type: inline-size;

  > div {
    flex-direction: column;
    [class*='__alert__icon'] {
      color: var(${DesignToken.ColorBlack});
    }

    @container (width >= 400px) {
      [class*='__alert__content__wrapper__cta']:not(button) {
        align-self: flex-start;
        margin-top: var(${SpacingToken.Spacing3});
        margin-left: var(${SpacingToken.Spacing11});
      }
    }
  }
`

interface Props extends AlertProps {
  children: ReactNode
}

const InfoAlert = ({ children, ...rest }: Props) => {
  return (
    <Alert kind="info" css={alertCss} {...rest}>
      {children}
    </Alert>
  )
}

export default InfoAlert
